const perksOfJoining = [
    {
        "img": "workIcon",
        "title": "Exciting Projects",
        "content": "Strengthen your profile by learning new things and working on cool and amazing projects. Working on Club Projects is really lot of fun and insightful.",
        "buttonText": "View Past Projects",
        "href": "/projects",
    },
    {
        "img": "exploreIcon",
        "title": "Explore New Fields",
        "content": "We are working on various interesting domains which are directly or indirectly related to electronics. We always try to be in phase with upcoming technogies.",
        "buttonText": "Domains in Club",
        "href": "/fields",
    },
    {
        "img": "alarmIcon",
        "title": "Competitions and Workshops",
        "content": "Competition stimulates achievement and contributes a lot to social and technical growth. We also conduct workshops where we impart the basics of the domains.",
        "buttonText": "Learn More",
        "href": "/competitionsandworkshops",
    },
    {
        "img": "groupAddIcon",
        "title": "Community",
        "content": "Work with like-minded people and build a strong community. We also have a strong alumni network who can guide you at required time.",
        "buttonText": "Learn More",
        "href": "/community"
    }
]

export default perksOfJoining;